import { render } from "./DeveloperPage.vue?vue&type=template&id=07ab14ba&scoped=true"
import script from "./DeveloperPage.vue?vue&type=script&lang=js"
export * from "./DeveloperPage.vue?vue&type=script&lang=js"

import "./DeveloperPage.vue?vue&type=style&index=0&id=07ab14ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ab14ba"]])

export default __exports__